import React, { useRef, useEffect, useState } from "react";
import $ from "jquery";
import { useDispatch } from "react-redux";
import contriesList from "iso-3166-1-alpha-2";
import * as R from "ramda";
import { addServiceData, updateServiceData, deleteServiceData } from "../../../../../actions/services-api";
import { generateLettersForUserIdAndUserServiceId } from "../../../../../actions/events-api";

//import { createServiceData, updateServiceData, deleteServiceData, generateLettersForUserIdAndUserServiceId } from '../../../../../actions/facilita-api';
import ServiceData from "../../../../../constants/models/serviceData";
import { ConnectionTypes, convertConnectionTypesToServiceType } from "../../../../../constants/utils/connectionTypes";
import AddressInfo from "../../../../../constants/models/addressInfo";
import { PostalCityInput } from "../../../../../_common/postalCityInput";

export const EhpadDetails = ({ index, activity, userId, removeActivity, generateRelocationLetters }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const dispatch = useDispatch();

	const formRef = useRef(null);
	let name = undefined;
	let initCollapsedState = true;
	let initState = {
		type: "Ehpad",
		name: "",
		address: new AddressInfo({ addressCountry: "FR", streetAddress: "", streetAddress2: "", postalCode: "", addressLocality: "" }),
	};
	if (!R.isNil(activity.id)) {
		initState = activity.payload;
		initCollapsedState = false;
		name = activity.payload.name;
	}
	const [payload, setPayload] = useState({ ...initState });
	const [collapsed, setCollapsed] = useState(initCollapsedState);

	useEffect(() => {
		if (!R.isNil(activity.payload)) {
			setPayload({ ...activity.payload });
		}

		if (!R.isNil(activity.id)) {
			setCollapsed(false);
		}
	}, [activity]);

	$('[data-toggle="tooltip"]').tooltip();
	return (
		<section className={"card card-body" + (index === 0 ? "" : " mt-4")} id={"activity" + index}>
			<div className="card-header p-0" id="headingUserDetail" role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
				<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#accordionActivities" + index} aria-expanded={collapsed} aria-controls="accordionActivities">
					<h4 className="h3 font-weight-black container-tight my-auto">{index === 0 ? "Etablissement principal" : "Autre établissement"}</h4>
					{!R.isNil(name) ? (
						<span className="mr-auto align-middle">
							<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
							<span className="o-60 align-middle">{name}</span>
						</span>
					) : (
						""
					)}
					<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
						<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
					</button>
				</div>
			</div>
			<div className={"mt-4 collapse" + (collapsed ? " show" : "")} id={"accordionActivities" + index} aria-labelledby="headingUserDetail" data-parent={"#activity" + index}>
				<form className="block" noValidate ref={formRef}>
					{/* <h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm mt-4">nom du propriétaire ou du cabinet</h5> */}
					<div className="row gx-2 mt-n2">
						<div className="col-12 col-md-5">
							<div className="form-group">
								<label className="h6 font-weight-bolder my-auto" htmlFor={"name" + index}>
									Nom de l'établissement
								</label>
								<input required type="text" className="form-control" id={"name" + index} placeholder="Etablissement" value={payload.name} onChange={(e) => setPayload({ ...payload, name: e.target.value })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
						</div>
						<div className="col-12 col-md-7">
							<div className="form-group">
								<label className="label h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
									Adresse ligne 1
								</label>
								<input required type="text" className="form-control" id={"Adresseentreprise" + index} placeholder="Adresse de l'entreprise" value={payload.address.streetAddress} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress: e.target.value } })} />
								<div className="invalid-feedback">
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Ce champ est requis</span>
								</div>
							</div>
							<div className="form-group">
								<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + index}>
									Adresse ligne 2
								</label>
								<input type="text" className="form-control rounded" id={"Adresseligne2" + index} placeholder="(optionnel)" value={payload.address.streetAddress2} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, streetAddress2: e.target.value } })} />
							</div>
							<div className="form-row">
								<PostalCityInput
									postalCode={payload.address.postalCode}
									city={payload.address.addressLocality}
									onChange={(updatedAddress) => setPayload({ ...payload, address: { ...payload.address, postalCode: updatedAddress.postalCode, addressLocality: updatedAddress.city } })}
									hasWrapper={false}
									country={payload.address.addressCountry}
									customClasses={{ city: "form-group col-12 col-sm-6 col-lg", postalCode: "form-group col-12 col-sm-6 col-lg" }}
								/>
								{/* <div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise" + index} required>
										Code Postal
									</label>
									<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={payload.address.postalCode} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, postalCode: e.target.value } })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div>
								<div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise" + index} required>
										Ville
									</label>
									<input required type="text" className="form-control" id={"Villeentreprise" + index} placeholder="ex: Paris" value={payload.address.addressLocality} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressLocality: e.target.value } })} />
									<div className="invalid-feedback">
										<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
										<span className="align-middle text-dark o-70">Ce champ est requis</span>
									</div>
								</div> */}
								<div className="form-group col-12 col-sm-6 col-lg">
									<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise" + index}>
										Pays
									</label>
									<select className="custom-select" id={"Paysentreprise" + index} value={payload.address.addressCountry} onChange={(e) => setPayload({ ...payload, address: { ...payload.address, addressCountry: e.target.value } })}>
										{Object.keys(contriesList.getData()).map((country, idx) => {
											return (
												<option key={idx} value={country}>
													{countries.getName(country, "fr", { select: "official" })}
												</option>
											);
										})}
									</select>
								</div>
							</div>
						</div>
					</div>
					<hr className="my-0" />
					<div className="card-footer text-right px-0">
						<button
							className="btn btn-sm btn-alert-info border-none loading-btn"
							onClick={(e) => {
								e.preventDefault();
								if (formRef.current.checkValidity()) {
									const serviceData = new ServiceData({ userId: userId, serviceType: convertConnectionTypesToServiceType(ConnectionTypes.ehpad), serviceId: "ehpad" + index, payload: { ...payload }, lifeEvent: payload.lifeEvent || 1 });
									if (R.isNil(activity.id)) {
										dispatch(addServiceData(serviceData)).then((s) => {
											if (generateRelocationLetters) {
												dispatch(generateLettersForUserIdAndUserServiceId(userId, s.id, "relocation"));
											}
										});
									} else {
										serviceData.id = activity.id;
										dispatch(updateServiceData(serviceData)).then((s) => {
											if (generateRelocationLetters) {
												dispatch(generateLettersForUserIdAndUserServiceId(userId, s.id, "relocation"));
											}
										});
									}
									setCollapsed(!collapsed);
								}
								formRef.current.classList.add("was-validated");
							}}>
							enregistrer
							<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
						</button>
						{index === 0 ? (
							""
						) : (
							<span
								className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
								id="basic-addon2"
								onClick={(e) => {
									e.preventDefault();
									if (R.isNil(activity.id)) {
										removeActivity(activity);
									} else {
										dispatch(deleteServiceData(activity.id, ConnectionTypes.ehpad));
									}
								}}>
								<i className="eva eva-trash-outline"></i>
							</span>
						)}
					</div>
				</form>
			</div>
		</section>
	);
};
